<template>
    <div>
        <div class="title" v-bind:class="{active: active}" v-on:click="onToggleItem">
            <slot name="title" v-bind:loading="loading" v-bind:active="active" v-bind:lock="lock"></slot>
        </div>
        <div ref="content" class="active content" v-if="active">
            <slot name="content" v-bind:loading="loading" v-bind:lock="lock" v-bind:index="index"></slot>
        </div>
    </div>
</template>

<script>
import SmoothReflow from 'vue-smooth-reflow'

export default {
    mixins: [SmoothReflow],
    props: {
      model: Object,
    },
    data() {
        return {
            active: false,
            loading: false,
            index: null
        }
    },
    mounted() {
        this.$smoothReflow({
            el: this.$el,
            property: ['height'],
            transition: 'height 0.25s ease-in-out'
        })

        let parent = this.$parent

        while (parent !== undefined && parent.$options._componentTag !== 'ui-accordion') {
            parent = parent.$parent
        }

        if (parent === null) {
            throw Error('Parent must be an accordion')
        }

        parent.add(this)

        this.$_parent = parent

        if(this.model && this.model.type === 'building' && this.model.id === this.$store.state.addedBuildingId) {
          this.toggle()
        }
        if(this.model && this.model.type === 'shaft' && this.model.id === this.$store.state.addedShaftId) {
          this.active = true
      }
    },
    destroyed() {
        this.$_parent.remove(this)
    },
    methods: {
        onToggleItem() {
            this.toggle()
        },
        toggle() {
            this.$el.dispatchEvent(
                new CustomEvent('toggle', {detail: {item: this}, bubbles: true, composed: true})
            )
        }
    },
    computed: {
        lock() {
            return this.$_parent && this.$_parent.lock
        }
    }
}
</script>